import styles from "./styles.module.scss";
import cx from 'classnames';
import { forwardRef } from 'react';
import Tooltip from 'src/components/tooltip';

interface InputGroupProps {
  label: string;
  value?: string;
  name?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  disabled?: boolean;
  type?: string;
  className?: string;
  infoIcon?: {
    show: boolean;
    tooltip?: string;
  };
}

const InputGroup = forwardRef<HTMLInputElement, InputGroupProps>(({
  label,
  value,
  name,
  placeholder,
  type,
  onChange,
  errorMessage,
  disabled,
  className,
  infoIcon,
}, ref) => {

  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.labelContainer}>
        <label className={styles.label}> {label}</label>
        {infoIcon?.show && (
          <Tooltip placement="left" content={infoIcon.tooltip} nowrap>
            <i className={cx('paperflite-info', styles.infoIcon)} />
          </Tooltip>
        )}
      </div>
      <div className={styles.inputWrapper}>
        <input
          ref={ref}
          className={cx(styles.field, { [styles.errorField]: errorMessage })}
          type={ type ?? 'text'}
          value={value}
          name={name}
          placeholder={placeholder ?? 'enter here'}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      {errorMessage && <p className={styles.error}>{errorMessage}</p>}
    </div>
  );
});

InputGroup.displayName = 'InputGroup';

export default InputGroup;